export default __webpack_public_path__ + "static/media/portside.46c28b79.png";